import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@auth0/auth0-angular';
import { ScopeService } from '@shared/services';
import { firstValueFrom } from 'rxjs';
import { Menu, MenuService } from './menu.service';

const MENU: Menu[] = [
  {
    route: 'community-club-onboarding',
    name: 'communityClubOnboarding',
    type: 'link',
    icon: 'fact_check',
  },
];

/**
 * Deliberately lean compared to the management-portal's `StartupService`: no `ngx-permissions`/
 * `userRoles` role loading (this app has no company-scoped roles, see `ScopeService`), no
 * dynamic menu built from company context (Gyms/CommunityClubs) - just the one feature this
 * dashboard has today.
 */
@Injectable({ providedIn: 'root' })
export class StartupService {
  private readonly _auth = inject(AuthService);
  private readonly _scopeService = inject(ScopeService);
  private readonly _menuService = inject(MenuService);
  private readonly _title = inject(Title);

  async load(): Promise<void> {
    this._title.setTitle('TrainToGo Admin Dashboard');

    const isAuthenticated = await firstValueFrom(this._auth.isAuthenticated$);
    if (isAuthenticated) {
      await this._scopeService.loadScopes();
    }

    const menu = structuredClone(MENU);
    this._menuService.addNamespace(menu, 'menu');
    this._menuService.set(menu);
  }
}
